var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarTemperatureLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.3334C10.9496 18.3335 11.8758 18.0387 12.6506 17.4897C13.4254 16.9407 14.0106 16.1646 14.3252 15.2686C14.6398 14.3727 14.6684 13.4011 14.407 12.4882C14.1455 11.5753 13.607 10.7661 12.8658 10.1725C12.755 10.0882 12.6645 9.97994 12.6012 9.85588C12.5379 9.73182 12.5033 9.5951 12.5 9.45585V4.16669C12.5 3.50365 12.2366 2.86776 11.7677 2.39892C11.2989 1.93008 10.663 1.66669 9.99996 1.66669C9.33692 1.66669 8.70103 1.93008 8.23219 2.39892C7.76335 2.86776 7.49996 3.50365 7.49996 4.16669V9.45669C7.49996 9.73835 7.35413 9.99669 7.13413 10.1734C6.39325 10.767 5.85502 11.5761 5.59379 12.4889C5.33255 13.4017 5.36122 14.373 5.67581 15.2688C5.99041 16.1645 6.57541 16.9405 7.35001 17.4895C8.1246 18.0384 9.05056 18.3333 9.99996 18.3334Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 13.75C12.0833 14.3026 11.8638 14.8325 11.4731 15.2232C11.0824 15.6139 10.5525 15.8334 9.99996 15.8334C9.44742 15.8334 8.91752 15.6139 8.52682 15.2232C8.13612 14.8325 7.91663 14.3026 7.91663 13.75C7.91663 13.1975 8.13612 12.6676 8.52682 12.2769C8.91752 11.8862 9.44742 11.6667 9.99996 11.6667C10.5525 11.6667 11.0824 11.8862 11.4731 12.2769C11.8638 12.6676 12.0833 13.1975 12.0833 13.75Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.6667V4.16669",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarTemperatureLinear);
export default __webpack_public_path__ + "static/media/solar_temperature-linear.9e8d836c215be2dcb635147860a41066.svg";
export { ForwardRef as ReactComponent };